import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { ValuablesType } from '@mona/models';
import { EncountersActions } from '@mona/pdms/data-access-encounters';
import { ValuablesState } from '../../entities';
import { ValuablesAction } from '../actions';

export const valuablesAdapter: EntityAdapter<ValuablesType> = createEntityAdapter<ValuablesType>();

export const initialState: ValuablesState = valuablesAdapter.getInitialState({
    error: null,
    isLoading: false,
});

export const valuablesReducer = createReducer(
    initialState,
    on(ValuablesAction.loadValuables, state => ({ ...state, isLoading: true })),
    on(ValuablesAction.loadValuablesSuccess, (state, { data }) =>
        // Use upsertMany instead of setAll so optimistic local entries (added/updated between
        // dispatching `loadValuables` and the response arriving, or by a WS push that landed
        // before the GET completed) are not wiped out. Deletions propagate via the dedicated
        // `addValuablesChanges` action (WS push).
        valuablesAdapter.upsertMany(data, {
            ...state,
            error: null,
            isLoading: false,
        }),
    ),
    on(ValuablesAction.loadValuablesFailure, (state, { error }) => ({
        ...state,
        error,
        isLoading: false,
    })),
    on(ValuablesAction.loadValuablesCancelled, state => ({
        ...state,
        isLoading: false,
        error: null,
    })),
    on(ValuablesAction.updateValuables, (state, action) => valuablesAdapter.updateMany(action.update, state)),
    on(ValuablesAction.upsertValuables, (state, action) => valuablesAdapter.upsertMany(action.data, state)),
    /**
     * Defensive reset for the MD-9750 stuck-spinner family.
     */
    on(ValuablesAction.clearValuables, EncountersActions.clearEncounter, state =>
        valuablesAdapter.removeAll({
            ...state,
            isLoading: false,
            error: null,
        }),
    ),
    on(ValuablesAction.addValuablesChanges, (state, { toRemoveIds, toUpdateEntities }) => {
        const newState = valuablesAdapter.removeMany(toRemoveIds, state);

        return valuablesAdapter.upsertMany(toUpdateEntities, newState);
    }),
);
